import React from 'react';
import Styles from './styled';
import theme from '../../../../styles/theme';

export default () => (
  <Styles
    width='321'
    height='206'
    viewBox='0 0 321 206'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className='icon-message_success'
  >
    <path
      d='M94.1 54.0779C108.791 54.0779 120.7 42.1687 120.7 27.4779C120.7 12.7872 108.791 0.87793 94.1 0.87793C79.4092 0.87793 67.5 12.7872 67.5 27.4779C67.5 42.1687 79.4092 54.0779 94.1 54.0779Z'
      stroke='#CDEAF9'
      stroke-miterlimit='10'
      className='circle-left'
    />
    <path
      d='M248.8 205.078C278.181 205.078 302 181.259 302 151.878C302 122.496 278.181 98.6777 248.8 98.6777C219.418 98.6777 195.6 122.496 195.6 151.878C195.6 181.259 219.418 205.078 248.8 205.078Z'
      stroke='#CDEAF9'
      stroke-miterlimit='10'
      className='circle-right'
    />
    <g className='envelope-smiling'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M240.6 173.379L106.6 191.979L94.0996 102.379L152.5 31.4785L228.1 83.7785L240.6 173.379Z'
        fill={theme.colors.vmfBlue}
      />
      <path
        d='M204.477 4.86885L95.335 20.0654L115.51 164.961L224.652 149.764L204.477 4.86885Z'
        fill='#91CCEF'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M94.0996 102.378L240.6 173.378L106.6 191.978L94.0996 102.378Z'
        fill='#F38074'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M228.1 83.7783L106.6 191.978L240.6 173.378L228.1 83.7783Z'
        fill='#004B8C'
      />
      {/* // TODO: Remove happy houses
       <path
        d="M157.6 93.2783C173.34 93.2783 186.1 80.5184 186.1 64.7783C186.1 49.0382 173.34 36.2783 157.6 36.2783C141.859 36.2783 129.1 49.0382 129.1 64.7783C129.1 80.5184 141.859 93.2783 157.6 93.2783Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M159.5 78.5783C165.6 77.6783 170.1 72.6783 170.4 66.6783C170.5 65.3783 169.3 64.3783 168.1 64.5783L147.5 67.4783C146.2 67.6783 145.4 68.8783 145.8 70.0783C147.7 75.7783 153.4 79.4783 159.5 78.5783Z"
        fill="#90CBEE"
      />
      <path
        d="M147 62.1783C146.5 62.2783 145.9 61.9783 145.7 61.4783C145.3 60.6783 144.4 60.2783 143.5 60.3783C142.6 60.4783 141.9 61.1783 141.7 62.0783C141.5 62.7783 140.8 63.2783 140.1 63.0783C139.4 62.8783 138.9 62.1783 139.1 61.4783C139.5 59.5783 141.2 58.0783 143.1 57.7783C145.1 57.4783 147 58.4783 148 60.2783C148.3 60.8783 148.1 61.6783 147.5 62.0783C147.3 62.0783 147.1 62.1783 147 62.1783Z"
        fill="#90CBEE"
      />
      <path
        d="M173.5 58.4781C173 58.5781 172.4 58.2781 172.2 57.7781C171.8 56.9781 170.9 56.5781 170 56.6781C169.1 56.7781 168.4 57.4781 168.2 58.3781C168 59.0781 167.3 59.5781 166.6 59.3781C165.9 59.1781 165.4 58.4781 165.6 57.7781C166 55.8781 167.6 54.3781 169.6 54.0781C171.6 53.7781 173.5 54.7781 174.5 56.5781C174.8 57.1781 174.6 57.9781 174 58.3781C173.8 58.3781 173.6 58.4781 173.5 58.4781Z"
        fill="#90CBEE"
      /> */}
    </g>
    <g className='envelope-right'>
      <path d='M320.9 132.478H283V161.978H320.9V132.478Z' fill='#CDEAF9' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M283 132.478L302 147.178L321 132.478H283Z'
        fill='#91CCEF'
      />
    </g>
    <g className='envelope-left'>
      <path d='M51.6 63.6777H0V103.878H51.6V63.6777Z' fill='#CDEAF9' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0 63.6777L25.8 83.7777L51.6 63.6777H0Z'
        fill='#91CCEF'
      />
    </g>
    <path
      d='M236.9 43.6783C238.944 43.6783 240.6 42.0218 240.6 39.9783C240.6 37.9349 238.944 36.2783 236.9 36.2783C234.857 36.2783 233.2 37.9349 233.2 39.9783C233.2 42.0218 234.857 43.6783 236.9 43.6783Z'
      fill='#CDEAF9'
      className='dot-right'
    />
    <path
      d='M58.2996 150.878C60.3431 150.878 61.9996 149.221 61.9996 147.178C61.9996 145.134 60.3431 143.478 58.2996 143.478C56.2562 143.478 54.5996 145.134 54.5996 147.178C54.5996 149.221 56.2562 150.878 58.2996 150.878Z'
      fill='#CDEAF9'
      className='dot-left'
    />
  </Styles>
);
